import React from "react"
import PropTypes from "prop-types"

import PlusIcon from "shared/components/icons/plus_icon"
import { verifyIntendedPromiseRejection } from "./utils/modal_promise"

import "./diy_add_tanda_button.scss"

export default function DIYAddTandaButton({ onClick, anchorTitle }) {
  return (
    <a
      className="button-tertiary"
      styleName="add"
      onClick={verifyIntendedPromiseRejection(onClick)}
      title={anchorTitle}
    >
      <PlusIcon />
    </a>
  )
}

DIYAddTandaButton.propTypes = {
  anchorTitle: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}
